import React from "react";
import { Tooltip } from "react-tooltip";
import Button from "../../form/Button";

const DashBoardReportCenter = () => {
  return (
      <div className="relative bg-white rounded-lg shadow divide-y divide-slate-200 w-full min-h-[600px] p-4">
        <div className="text-base text-slate-800 font-bold leading-none px-3 py-3">
          REPORT CENTER
        </div>
        <div className="px-3 py-3 border-y border-slate-200 space-y-2">
          <div
            className="sm:ml-auto flex justify-center items-center"
            data-tooltip-id={`planhistory${1344}`}
            data-tooltip-place="top"
          >
            <Button
              buttonType={"button"}
              buttonLabel={"Completed Company Succession Plans"}
              buttonClasses={" !w-full"}
              buttonHasLink={true}
              buttonLink={"/planhistory"}
            />
            <Tooltip
              id={`planhistory${1344}`}
              className="!text-xs !bg-dark-teal-600 z-50 rounded py-3 px-6"
              render={() => (
                <div className="gap-x-1">
                  <div className="text-[13px] font-normal leading-none flex items-center">
                    <div className="font-semibold">
                      Click to View Completed Company Succession Plans
                    </div>
                  </div>
                </div>
              )}
            />
          </div>

          <div
            className="sm:ml-auto flex justify-center items-center"
            data-tooltip-id={`boardstrength${133344}`}
            data-tooltip-place="top"
          >
            <Button
              buttonType={"button"}
              buttonLabel={"Board Strength Report"}
              buttonClasses={" !w-full"}
              buttonHasLink={true}
              buttonLink={"/boardstrength"}
            />
            <Tooltip
              id={`boardstrength${133344}`}
              className="!text-xs !bg-dark-teal-600 z-50 rounded py-3 px-6"
              render={() => (
                <div className="gap-x-1">
                  <div className="text-[13px] font-normal leading-none flex items-center">
                    <div className="font-semibold">
                      Click to View Board Strength Report
                    </div>
                  </div>
                </div>
              )}
            />
          </div>

          <button
            disabled
            className="block w-full text-center bg-gray-300 text-gray-500 py-2 rounded-lg cursor-not-allowed"
          >
            Proposed Board Members
          </button>

          <div
            className="sm:ml-auto flex justify-center items-center"
            data-tooltip-id={`emergency-replacement-plan${136644}`}
            data-tooltip-place="top"
          >
            <Button
              buttonType={"button"}
              buttonLabel={"Emergency Replacement Plan"}
              buttonClasses={" !w-full"}
              buttonHasLink={true}
              buttonLink={"/emergency-replacement-plan"}
            />
            <Tooltip
              id={`emergency-replacement-plan${136644}`}
              className="!text-xs !bg-dark-teal-600 z-50 rounded py-3 px-6"
              render={() => (
                <div className="gap-x-1">
                  <div className="text-[13px] font-normal leading-none flex items-center">
                    <div className="font-semibold">
                      Click to View Emergency Replacement Plan
                    </div>
                  </div>
                </div>
              )}
            />
          </div>

          <div
            className="sm:ml-auto flex justify-center items-center"
            data-tooltip-id={`executivestrength${186644}`}
            data-tooltip-place="top"
          >
            <Button
              buttonType={"button"}
              buttonLabel={"Executive Strength Report"}
              buttonClasses={" !w-full"}
              buttonHasLink={true}
              buttonLink={"/executivestrength"}
            />
            <Tooltip
              id={`executivestrength${186644}`}
              className="!text-xs !bg-dark-teal-600 z-50 rounded py-3 px-6"
              render={() => (
                <div className="gap-x-1">
                  <div className="text-[13px] font-normal leading-none flex items-center">
                    <div className="font-semibold">
                      Click to View Executive Strength Report
                    </div>
                  </div>
                </div>
              )}
            />
          </div>

          <div
            className="sm:ml-auto flex justify-center items-center"
            data-tooltip-id={`retirement-reports${1986644}`}
            data-tooltip-place="top"
          >
            <Button
              buttonType={"button"}
              buttonLabel={"Company Retirement Profile"}
              buttonClasses={" !w-full"}
              buttonHasLink={true}
              buttonLink={"/retirement-reports"}
            />
            <Tooltip
              id={`retirement-reports${1986644}`}
              className="!text-xs !bg-dark-teal-600 z-50 rounded py-3 px-6"
              render={() => (
                <div className="gap-x-1">
                  <div className="text-[13px] font-normal leading-none flex items-center">
                    <div className="font-semibold">
                      Click to View Company Retirement Profile
                    </div>
                  </div>
                </div>
              )}
            />
          </div>
        </div>
      </div>
  );
};

export default DashBoardReportCenter;
